<template lang="pug">
    main#Error
        section#uc.uc
            .container
                .uc__inner

                    .uc__box
                        img(src="@/assets/img/illust-error.svg", alt="Under Contruction Illustration").uc__box__illust
                        .uc__box__cp
                            h3 404 – Not Found
                            p The page you opened doesn't exist.<br>Want to return to home page?
                            router-link(to="/").btn.btn-md.btn-w-xs.btn-primary Yup!



</template>

<script>

export default {
  name: 'Error',
  components: {

  }
}
</script>

<style lang="sass">
@import "~@/scss/flavor.scss"

</style>
